import { Authentication } from '@components/Authentication';

export const withAuthentication = (Wrapped) => (props) => {
    return <Authentication {...props}>{(newProps) => <Wrapped {...newProps} />}</Authentication>;
};
